/* eslint-disable camelcase */
import { helpGetUserLoginAccountWithEmail } from "../../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail"

const handleGetUserLoginAccountData = async (param) => {
  try {
    const response = await helpGetUserLoginAccountWithEmail(param)

    if (!response.data) {
      return { error: true, notExistsUser: false }
    }
    const { auth_2faEnabled, auth_2faExpirationDate, loginAccountId } =
      response.data.loginAccount
    return {
      isActive: auth_2faEnabled,
      expirationDate: auth_2faExpirationDate,
      loginAccountId,
      error: false,
      notExistsUser: false,
    }
  } catch (err) {
    return {
      error: true,
      notExistsUser:
        err.response?.data?.error?.message === "Verify LoginAccount email.",
    }
  }
}

export default handleGetUserLoginAccountData
